import React from 'react';
import { FacebookProvider, CustomChat } from 'react-facebook';


const MessengerChat = () => {
  return (
    <div>
      <FacebookProvider appId="7191655627592531" chatSupport>
        <CustomChat pageId="150525878884722" minimized={true}/>
      </FacebookProvider>
    </div>
  )
}

export default MessengerChat;
